/* ==============================
   GLS Csomagpont (ParcelShop) választó
   Hivatalos GLS Map Widget integráció
   https://gls-group.com/HU/media/downloads/gls_map_widget_2026_02_10_en.pdf
   Widget JS: https://map.gls-hungary.com/widget/gls-dpm.js
   ============================== */

$(function () {

	/* ---------- widget példány ---------- */
	// A <gls-dpm-dialog> custom element a DOM-ban van (gls_pickup_modal.blade.php).
	// A type="module" script aszinkron tölti be – ezért delegáltan kezeljük az eseményt.

	function getWidgetEl() {
		return document.getElementById('glsDpmDialog');
	}

	/* ---------- a widget országa a checkout szállítási országát követi ---------- */

	function applySelectedCountry(el) {
		if (!el) return;
		var supported = window.glsSupportedCountries || ['HU'];
		var code = ($('#co_country').val() || '').toUpperCase();
		if (supported.indexOf(code) === -1) {
			code = 'HU';
		}
		el.setAttribute('country', code.toLowerCase());
	}

	// Országváltáskor a korábban választott csomagpont már nem érvényes.
	$(document).on('change', '#co_country', function () {
		applySelectedCountry(getWidgetEl());
		if (!$('#gls_parcelshop_id').val()) return;
		$('#gls_parcelshop_id').val('');
		$('#gls_parcelshop_name').val('');
		$('#gls_parcelshop_address').val('');
		$('#glsPickupName').text(window.Lang.co_no_parcel);
		$('#glsPickupAddress').text('');
		$(document).trigger('glsParcelShopSelected');
	});

	/* ---------- widget megnyitása a "Csomagpont választása" gombra ---------- */

	$(document).on('click', '#glsPickupSelectBtn', function () {
		var el = getWidgetEl();
		if (!el) {
			console.error('GLS widget elem (#glsDpmDialog) nem található a DOM-ban.');
			return;
		}
		applySelectedCountry(el);
		if (typeof el.showModal !== 'function') {
			// A JS modul még nem töltődött be teljesen – rövid várakozás után újra
			var attempts = 0;
			var interval = setInterval(function () {
				attempts++;
				var el2 = getWidgetEl();
				if (el2 && typeof el2.showModal === 'function') {
					clearInterval(interval);
					applySelectedCountry(el2);
					el2.showModal();
					bindChangeEvent(el2);
				} else if (attempts >= 20) {
					clearInterval(interval);
					console.error('GLS widget showModal() nem elérhető.');
				}
			}, 150);
			return;
		}
		el.showModal();
		bindChangeEvent(el);
	});

	/* ---------- change esemény a kiválasztott csomagpontra ---------- */

	var _changesBound = false;
	function bindChangeEvent(el) {
		if (_changesBound) return;
		_changesBound = true;
		el.addEventListener('change', function (e) {
			var point = e.detail;
			if (!point) return;

			/*
			 * e.detail struktúra (a widget dokumentációja alapján):
			 * {
			 *   id:      "1011-ALPHAZOOKF",
			 *   name:    "Alpha Zoo Batthyány tér",
			 *   contact: {
			 *     countryCode: "HU",
			 *     postalCode:  "1011",
			 *     city:        "Budapest I. kerület",
			 *     address:     "Batthyány tér 5-6.",
			 *     name:        "Ügyfélszolgálat",
			 *     email:       "..."
			 *   }
			 * }
			 */

			var id = point.id || '';
			var name = point.name || '';
			var contact = point.contact || {};
			var addrParts = [];
			if (contact.postalCode) addrParts.push(contact.postalCode);
			if (contact.city) addrParts.push(contact.city);
			if (contact.address) addrParts.push(contact.address);
			var address = addrParts.join(', ');

			// Hidden inputok feltöltése (ezek kerülnek a Stripe/checkout POST-ba)
			$('#gls_parcelshop_id').val(id);
			$('#gls_parcelshop_name').val(name);
			$('#gls_parcelshop_address').val(address);

			// Checkout oldal UI frissítése
			$('#glsPickupName').text(name);
			$('#glsPickupAddress').text(address);
			$('#glsPickupError').hide().text('');

			// Esemény kiváltása – checkout.js figyeli a submit gomb állapotához
			$(document).trigger('glsParcelShopSelected');
		});
	}

	/* ---------- widget DOM-ba kerülésekor is bekötjük az eseményt ----------
	   (CustomElement esetén a browser DOM-ready előtt is definiálhatja magát) */
	var domReady = setInterval(function () {
		var el = getWidgetEl();
		if (el && typeof el.showModal === 'function') {
			clearInterval(domReady);
			bindChangeEvent(el);
		}
	}, 300);

	// 10s után leállítjuk a polling-ot
	setTimeout(function () { clearInterval(domReady); }, 10000);

});
